import { isSmDown } from '~/lib/responsive';
import type { SignalFiltersState, useSignalFiltersParams } from './';

export const INITIAL_KIND = [
  { label: 'Event', selected: false, value: 'EVENT' as const },
  { label: 'Manual', selected: false, value: 'MANUAL' as const },
];

export const INITIAL_ACTION = [
  { label: 'Play Overlay', selected: false, value: 'PLAY_OVERLAY' as const },
  { label: 'Play Show', selected: false, value: 'PLAY_SHOW' as const },
  { label: 'Stop Overlay', selected: false, value: 'STOP_OVERLAY' as const },
  { label: 'Trigger View', selected: false, value: 'TRIGGER_VIEW' as const },
  { label: 'Tune Channel', selected: false, value: 'TUNE_CHANNEL' as const },
  { label: 'Turn TV Off', selected: false, value: 'TV_OFF' as const },
  { label: 'Turn TV On', selected: false, value: 'TV_ON' as const },
];

export const allUnselectedState: SignalFiltersState = {
  filters: {
    action: { open: false, items: INITIAL_ACTION },
    eventType: { open: false, items: [] },
    kind: { open: false, items: INITIAL_KIND },
    tags: { open: false, items: [] },
  },
  panel: { open: false },
};

export const getSignalFiltersState = (params: ReturnType<typeof useSignalFiltersParams>) => {
  const smDown = isSmDown();
  return {
    filters: {
      action: {
        open: params.action.length > 0,
        items: INITIAL_ACTION.map((x) => ({ ...x, selected: params.action.includes(x.value) })),
      },
      eventType: { open: params.eventType.length > 0, items: [] },
      kind: {
        open: params.kind.length > 0,
        items: INITIAL_KIND.map((x) => ({ ...x, selected: params.kind.includes(x.value) })),
      },
      tags: { open: params.tags.length > 0, items: [] },
    },
    panel: { open: !smDown && Object.values(params).flat().length > 0 },
  };
};
